<p-dropdown
  #dropdown
  i18n-placeholder
  placeholder="— Please select —"
  [style]="{ width: '100%' }"
  [options]="sortingOptions"
  [(ngModel)]="selectedItem"
  [optionLabel]="$any(displayExpr)"
  [optionValue]="'value'"
  [dropdownIcon]="getDropdownIcon()"
  (onChange)="selectedItemChanges($event)"
>
  <ng-template pTemplate="selectedItem">
    <ng-container *ngIf="selectedLabel; else selectedItemPlaceholder">
      <div class="sort__container">
        <span i18n>Sort by: </span><span class="sort__container__label">{{ selectedLabel }}</span>
      </div>
    </ng-container>
    <ng-template #selectedItemPlaceholder>
      <span i18n>— Please select —</span>
    </ng-template>
  </ng-template>
  <ng-template [pTemplate]="'header'">
    <div [style]="{ textAlign: 'end' }">
      <lx-button [svg]="'remove'" [hasText]="false" [svgColor]="'dark'" [btnRounded]="true" [buttonStyle]="'plain-text'" (buttonClick)="toggleDropdown(false)">
      </lx-button>
    </div>
  </ng-template>
</p-dropdown>
